<template>
  <registerUserPopup
    :key="reRenderRegisterUserPopup"
    :show="showRegisterPopup"
    :locale="locale"
    :title="'Test'"
    :pre_firstname="pre_firstname"
    :pre_lastname="pre_lastname"
    :pre_email="pre_email"
    :pre_feide_username="pre_feide_username"
    :pre_mobile="pre_mobile"
    :pre_date_of_birth="pre_date_of_birth"
    @callback_register_result="callback_register_result"
    @callback_register_cancel="callback_register_cancel"
  />
</template>

<script>
import registerUserPopup from "../partials/RegisterUserPopup.vue"

export default {
  name: "FeideAuthCallback",

  components: {
    registerUserPopup,
  },

  props: ["locale"],

  data() {
    return {
      reRenderRegisterUserPopup: 0,
      showRegisterPopup: false,
      pre_firstname: null,
      pre_lastname: null,
      pre_email: null,
      pre_feide_username: null,
      pre_mobile: null,
      pre_date_of_birth: null,
    }
  },

  created() {
    this.authToken()
  },

  methods: {
    authToken() {
      let code = this.$route.query.code
      let state = this.$route.query.state

      axios
        .post(this.API_URL + "auth/feide/generateAccessToken", {
          code: code,
          state: state,
        })
        .then(res => {
          if (res.status == 200 && res.data.access_token) {
            this.$cookies.set(
              `${this.COOKIE_PREFIX}feide_access_token`,
              res.data.access_token,
            )

            // Check user if in system
            axios
              .post(this.API_URL + "auth/feide/validateUser", {
                token: res.data.access_token,
              })
              .then(res => {
                if (res.status == 200) {
                  let data = res.data

                  if (!data.user_id) {
                    this.$awn.confirm(
                      this.$t("auth.feide_want_to_add", {
                        name:
                          data.feide_first_name + " " + data.feide_last_name,
                        email: data.feide_email,
                      }),
                      () => {
                        this.pre_firstname = data.feide_first_name
                        this.pre_lastname = data.feide_last_name
                        this.pre_email = data.feide_email
                        this.pre_feide_username = data.feide_username
                        this.pre_mobile = data.feide_mobile
                        this.pre_date_of_birth = data.feide_birthdate

                        this.reRenderRegisterUserPopup += 1
                        this.showRegisterPopup = true
                      },
                      () => {
                        this.$awn.alert(this.$t("auth.feide_no_add"))
                        this.$router.push("/auth/no/login")
                      },
                      {
                        labels: {
                          confirmOk: this.$t("global.yes"),
                          confirmCancel: this.$t("global.no"),
                        },
                      },
                    )
                  } else {
                    // Login user via id
                    axios
                      .post(this.API_URL + "auth/loginUser", {
                        id: data.user_id,
                        token: data.user_login_token,
                        type: "feide",
                      })
                      .then(res => {
                        this.postLogin(res.data)
                      })
                      .catch(err => console.log(err))
                  }
                }
              })
              .catch(() => {})
          } else {
            this.$awn.alert(
              this.$t("auth.error_feide_failed_to_generate_token"),
            )
            this.$router.push("/auth/no/login")
          }
        })
        .catch(() => {
          this.$awn.alert(this.$t("auth.error_feide_failed_to_generate_token"))
          this.$router.push("/auth/no/login")
        })
    },

    loginUser(id, token) {
      axios
        .post(this.API_URL + "auth/loginUser", {
          id: id,
          token: token,
          type: "feide",
        })
        .then(res => {
          this.postLogin(res.data)
        })
        .catch(err => console.log(err))
    },

    postLogin(data) {
      let vm = this
      let token = data.access_token
      let user = data.user_data

      if (token && user) {
        let status = user.status
        let locale = "no"

        this.$cookies.set(`${this.COOKIE_PREFIX}access_token`, token)
        vm.$setAuthorization(token)
        vm.$init(token, user)

        let localesetting = user.settings.find(i => i.key == "locale")
        if (localesetting && localesetting.value) {
          locale = localesetting.value
        }

        this.$updateSetting("fe_locale", locale)
        this.$updateSetting("locale", locale)
        this.$i18n.locale = locale

        if (status == 1) {
          // After login redirects
          if (vm.$hasRole("system-developer") || vm.$hasRole("superuser")) {
            vm.$router.push(vm.BACKEND_URL + "/dashboard")
          } else {
            vm.$router.push(vm.BACKEND_URL + "/my")
          }
        } else if (status == 3) {
          this.$router.push("/auth/" + locale + "/forcechangepassword")
        }
      } else {
        vm.$awn.alert(vm.$t("auth.login_error"))
      }
    },

    callback_register_result(data) {
      if (data.status) {
        this.loginUser(data.id, data.login_token)
      }
    },

    callback_register_cancel() {
      this.$awn.alert(this.$t("auth.feide_no_add"))
      this.$router.push("/auth/no/login")
    },
  },
}
</script>
